import {AxiosResponse} from "axios";

import ResourceApi from "@/src/modules/core/api/resource-api";
import type {GetResponse} from "@/src/modules/core/types";

import type {
  CreateStoredVehicleFollowUpPayload,
  CreateStoredVehiclePayload,
  StoredVehicle,
  StoredVehicleFollowUp,
  UpdateStoredVehiclePayload,
} from "../types";

const PATH = "stored-vehicle";
const LIST_PATH = "stored-vehicles";

class StoredVehiclesApi extends ResourceApi<StoredVehicle> {
  constructor() {
    super(PATH, {listPath: LIST_PATH});
  }

  create(data: CreateStoredVehiclePayload): Promise<AxiosResponse<GetResponse<StoredVehicle>>> {
    return super.create(data);
  }

  update(
    id: number,
    data: UpdateStoredVehiclePayload,
  ): Promise<AxiosResponse<GetResponse<StoredVehicle>>> {
    return super.update(id, data);
  }

  createFollowUp(
    storedVehicleId: number,
    data: CreateStoredVehicleFollowUpPayload,
  ): Promise<AxiosResponse<GetResponse<StoredVehicleFollowUp>>> {
    return this.post(`${PATH}/${storedVehicleId}/follow-ups`, data);
  }
}

export const storedVehiclesApi = new StoredVehiclesApi();
